import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "../home";
import About from "../about";
import Plans from "../plans";
import Register from "../register";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/planos" element={<Plans />} />
        <Route path="register" element={<Register />} />
      </Routes>
    </BrowserRouter>
  ); 
};

export default AppRoutes;
